import React from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

// Live checklist for the auth password screens. The rules come from
// `usePasswordPolicy`, which reads them from the Firebase project, so this
// component renders a policy rather than defining one. `rules` is required on
// purpose: defaulting it to the bundled fallback would let a screen that
// forgot the hook render stale rules silently, which is the drift this whole
// arrangement exists to prevent.
export const PasswordRequirements = ({ password, rules }) => (
  <ul className="mt-2 mb-0 pl-0 list-none flex flex-col gap-[4px]">
    {rules.map(({ key, label, test }) => {
      const met = password ? test(password) : false;
      return (
        <li
          key={key}
          className="flex items-center gap-[6px] text-[13px]"
          style={{ color: met ? "#389e0d" : "#8c8c8c" }}
        >
          {met ? (
            <CheckCircleFilled style={{ fontSize: 13, color: "#389e0d" }} />
          ) : (
            <CloseCircleFilled style={{ fontSize: 13, color: "#d9d9d9" }} />
          )}
          {label}
        </li>
      );
    })}
  </ul>
);
